<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p28" title="28">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="apple_crisp_refrigerator_oatmeal">Apple Crisp Refrigerator Oatmeal</h2>
<p class="recipetime"><span class="yield_black">1 serving</span> <span class="separater">|</span> Prep Time: 5 Minutes <span class="separater">|</span> Start to Finish: 8 Hours 5 Minutes</p>
<p class="dot">•••</p>
<p class="ingredient_head">OATMEAL</p>
<ul class="ingredient1">
<li class="list"><span class="qty1">¼</span> cup old-fashioned oats</li>
<li class="list"><span class="qty1">1</span> container (6 oz) apple crisp low-fat yogurt</li>
<li class="list"><span class="qty1">1</span> teaspoon chia seed, if desired</li>
</ul>
<p class="ingredient_head">TOPPINGS, IF DESIRED</p>
<ul class="ingredient1">
<li class="list"><span class="qty1">¼</span> cup chopped Granny Smith apple</li>
<li class="list"><span class="qty1">⅛</span> teaspoon ground cinnamon</li>
<li class="list"><span class="qty1">2</span> tablespoons chopped walnuts</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> In half-pint canning jar (or other resealable container), place oats. Top with yogurt and chia seed; carefully stir to mix thoroughly. Cover; refrigerate about 8 hours.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> Sprinkle with toppings before serving.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 240; Total Fat 3g (Saturated Fat 1g, Trans Fat 0g); Cholesterol 10mg; Sodium 90mg; Total Carbohydrate 47g (Dietary Fiber 2g); Protein 7g <span class="nutr_bold">Exchanges:</span> 1½ Starch, 1½ Other Carbohydrate, ½ Fat <span class="nutr_bold">Carbohydrate Choices:</span> 3</p>
<p class="recipe_note"><span class="tips">Fresh Idea</span> Check out chia seed. It is an unprocessed whole grain with a mild nutty flavor. It helps to thicken dishes, like the oatmeal here. Chia seed’s thickening power is also great in smoothies.</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p028.vue?3b8db7fe